import { render, staticRenderFns } from "./uiDate.vue?vue&type=template&id=d5a5d362&scoped=true"
import script from "./uiDate.vue?vue&type=script&lang=js"
export * from "./uiDate.vue?vue&type=script&lang=js"
import style0 from "./uiDate.vue?vue&type=style&index=0&id=d5a5d362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a5d362",
  null
  
)

export default component.exports